import React from "react";
import NavbarVariant1 from "../components/Navbar/Variant1"
import NavbarVariant2 from "../components/Navbar/Variant2"
import NavbarVariant3 from "../components/Navbar/Variant3"

export const navbar_library = {
  navbar: {
    variant1: {
      name: "Classic Navbar",
      description: "Simple horizontal navigation bar.",
      Component: React.memo(NavbarVariant1),
      metadata: {
        tokens: {
          logo: { type: "text", default: "logo" },
          page_1: { type: "text", default: "Home" },
          page_2: { type: "text", default: "About" },
          page_3: { type: "text", default: "Contact" },
        },
      },
    },
    variant2: {
      name: "Modern Navbar",
      description: "Responsive navbar with dropdowns.",
      Component: React.memo(NavbarVariant2),
      metadata: {
        tokens: {
          brand: { type: "text", default: "Brand Name" },
          page_1: { type: "text", default: "Home" },
          page_2: { type: "text", default: "About" },
          page_3: { type: "text", default: "Services" },
          page_4: { type: "text", default: "Contact" },
        },
      },
    },
    variant3: {
      name: "Minimal Navbar",
      description: "Clean and minimalistic navbar.",
      Component: React.memo(NavbarVariant3),
      metadata: {
        tokens: {
          brand: { type: "text", default: "My Site" },
          page_1: { type: "text", default: "Home" },
          page_2: { type: "text", default: "Blog" },
          page_3: { type: "text", default: "About" },
          CTA: { type: "text", default: "Sign up" },
        },
      },
    },
  },
};
